import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '@hero/ui-kit/components/Loader';
import useIsMarketingAdmin from './hooks/useIsMarketingAdmin';

type Props = {
    children: React.ReactNode;
};

const isMarkPath = (pathname: string) => pathname === '/mark' || pathname.startsWith('/mark/');

const MarketingAdminBoundary: React.FC<Props> = ({ children }) => {
    const status = useIsMarketingAdmin();
    const { pathname } = useLocation();

    if (status === 'pending') return <Loader />;

    if (status === 'allowed' && !isMarkPath(pathname)) {
        return <Navigate to="/mark" replace />;
    }

    return <>{children}</>;
};

export default MarketingAdminBoundary;
